import MystarChargeList from './MystarChargeList';
import MystarChargeShow from './MystarChargeShow';
import ChargeIcon from '@material-ui/icons/Payment';

export default {
    list: MystarChargeList,
    show: MystarChargeShow,
    icon: ChargeIcon,
};
